/**
 * 预警 API — F1（契约见 kickoff 02 §6）。
 *
 * GET  /api/alerts         预警事件列表（brand_id/level/status/date_from/date_to/page/size）
 * GET  /api/alerts/summary 情报总览头部汇总
 * POST /api/alerts/{id}/resolve  标记处理（note 可空）
 *
 * 后端预警引擎并行开发中；调用方需自行 try/catch 做优雅降级。
 */
import client from "./client";
import type { AlertItem, AlertSummary, PaginatedData } from "../types";

/** 预警列表查询参数（均可选，brand_id 缺省=租户内全部）。 */
export interface AlertListParams {
  brand_id?: string;
  level?: "P0" | "P1";
  status?: "new" | "read" | "resolved";
  date_from?: string;
  date_to?: string;
  page?: number;
  size?: number;
}

/** 获取预警事件列表。 */
export async function getAlerts(
  params?: AlertListParams,
): Promise<PaginatedData<AlertItem>> {
  return client.get<unknown, PaginatedData<AlertItem>>("/alerts", { params });
}

/** 获取预警汇总（情报总览头部用）。 */
export async function getAlertSummary(brandId?: string): Promise<AlertSummary> {
  return client.get<unknown, AlertSummary>("/alerts/summary", {
    params: brandId ? { brand_id: brandId } : undefined,
  });
}

/** 标记处理（new/read → resolved；note 可空，备注"误报"参与 R-3 误报统计）。 */
export async function resolveAlert(id: string, note?: string): Promise<void> {
  return client.post<unknown, void>(`/alerts/${id}/resolve`, { note });
}
